import "./graphic-picker.style.scss";
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import DragImage from "../../Assets/applifecycle/drag_image.png";

import DragVideo from "../../Assets/applifecycle/drag_video.png";
import DeleteIcon from "../../Assets/deleteIcon.svg";

import AMStorageAPI from "./graphic-api";
import { CustomToast } from "../custom-toast/CustomToast";

function FileDropzone({ onFileSelect, type, fileTypeCheck, defaultPreview }) {
  const onDrop = useCallback((acceptedFiles) => {
    onFileSelect(acceptedFiles[0]);
    // acceptedFiles.forEach((file) => {
    //   const reader = new FileReader();

    //   reader.onabort = () => console.log("file reading was aborted");
    //   reader.onerror = () => console.log("file reading has failed");
    //   reader.onload = () => {
    //     // Do whatever you want with the file contents
    //     const binaryStr = reader.result;
    //     console.log(binaryStr);
    //   };
    //   reader.readAsArrayBuffer(file);
    // });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: fileTypeCheck,
    onDrop,
  });

  return (
    <div
      style={{ width: "100%", height: "100%", overflow: "hidden" }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <React.Fragment>
          <div
            // style={{ height: this.props.height, width: this.props.width }}
            className="graphic-select"
          >
            <img
              alt="img"
              src={
                type === "image"
                  ? defaultPreview
                    ? defaultPreview
                    : DragImage
                  : DragVideo
              }
            />
            <div className="graphic-select-overlay">
              <p>Drop to upload</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          // style={{ height: this.props.height, width: this.props.width }}
          className="graphic-select"
        >
          <img
            alt="img"
            src={
              type === "image"
                ? defaultPreview
                  ? defaultPreview
                  : DragImage
                : DragVideo
            }
          />
        </div>
      )}
    </div>
  );
}

export default class GraphicPicker extends React.Component {
  constructor(props) {
    super(props);
    console.log("this is props value in graphics picker >>>", props);
    this.state = {
      key: props.key || 0,
      status: props.preview !== undefined ? 2 : 0,
      name: "",
      progress: 0,
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken:
        props.preview !== undefined
          ? props.preview + "?" + Date.now().toString()
          : "",
      size: 0,
      path: "",
    };
  }

  generateSAS(filename) {
    var api = new AMStorageAPI();
    api
      .generateGraphicSAS(this.props.applicationId, {
        type: "graphics",
        fileName: filename,
      })
      .then((response) => {
        this.setState({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          sasUrlWithoutToken:
            response.data.data.url.replace("?" + response.data.data.token, "") +
            "?" +
            Date.now().toString(),
          path: response.data.data.path,
        });
        this.uploadFile();
      })
      .catch((error) => {
        console.log(error);
        this.showError("Unable to upload please try uploading again");
        CustomToast(error.response.data.message);
      });
  }
  uploadFile() {
    var api = new AMStorageAPI();

    api
      .uploadGraphicsFile(
        this.state.sasUrl,
        this.selectedFileData,
        (progress) => {
          this.setState({ progress: progress });
          console.log(progress);
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({ status: 2 });
        this.props.onComplete({
          fileName: this.state.sasFileName,
          url: this.state.sasUrlWithoutToken.split("?")[0],
          size: this.state.size,
          path: this.state.path,
        });
      })
      .catch((error) => {
        console.log(error);
        this.props.onComplete({ fileName: "", url: "", size: 0 });

        this.showError("Unable to upload please try uploading again");
      });
  }

  resetFile() {
    console.log(this.state, "this is satet in reset file");
    this.setState({
      key: 0,
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
      size: 0,
    });
    this.props.onComplete({ fileName: "", url: "", size: 0 });
  }

  handleFileSelect(file) {
    console.log(file, "this is file");
    if (file === undefined) {
      CustomToast("we only support JPG & JPEG");
      this.showError("we only support JPG & JPEG");
      return;
    }
    let fileExtension = "";
    let rest = "";

    if (file.name.lastIndexOf(".") > 0) {
      const fileArr = file.name.split(".");
      const finalLen = fileArr.length - 1;
      fileExtension = fileArr[finalLen].toLowerCase();
      rest = fileArr.splice(0, finalLen).join(".");
    }
    if (this.props.type === "image") {
      if (file.size / 1024 > 1024) {
        CustomToast("Only 1MB size is required");
        this.showError("Only 1MB size is required");
        return;
      }
      if (fileExtension !== "jpg" && fileExtension !== "jpeg") {
        CustomToast("Only JPG & JPEG are supported");
        this.showError("Only JPG & JPEG are supported");
        return;
      } else {
        this.setState({ name: this.props.graphicName + "." + fileExtension });
      }
    } else if (this.props.type === "video") {
      if (fileExtension !== "mp4") {
        CustomToast("Only MP4 file are supported");
        this.showError("Only MP4 file are supported");
        return;
      } else {
        this.setState({ name: this.props.graphicName + "." + fileExtension });
      }
      if (file.size / 1024 > 10240) {
        CustomToast("Only 10MB size is required");
        this.showError("Only 10MB size is required");
      }
    } else {
      CustomToast("Unknown File Type Selected");
      this.showError("Unknown File Type Selected");
      return;
    }

    if (this.props.type === "image") {
      const img = new Image();
      img.onload = () => {
        if (
          img.naturalWidth !== this.props.dimensionCheck.width ||
          img.naturalHeight !== this.props.dimensionCheck.height
        ) {
          CustomToast(
            `Dimension should be ${this.props.dimensionCheck.width}px X ${this.props.dimensionCheck.height}px `
          );
          this.showError(
            `Dimension should be ${this.props.dimensionCheck.width}px X ${this.props.dimensionCheck.height}px `
          );
          return;
        }
        this.resetFile();
        this.selectedFileData = file;
        this.setState({ size: file.size });
        this.generateSAS(
          rest + new Date().getTime().toString() + "." + fileExtension
        );
      };
      img.src = URL.createObjectURL(file);
    } else {
      this.resetFile();
      this.selectedFileData = file;
      this.setState({ size: file.size });
      this.generateSAS(
        rest + new Date().getTime().toString() + "." + fileExtension
      );
    }
  }

  showError(msg) {
    this.resetFile();
    this.setState({ errorMsg: msg });
  }

  render() {
    const comp = () => {
      switch (this.state.status) {
        case 0:
          return (
            <FileDropzone
              onFileSelect={(file) => {
                this.handleFileSelect(file);
              }}
              type={this.props.type}
              fileTypeCheck={this.props.fileTypeCheck}
              defaultPreview={this.props.defaultPreview}
            />
          );
        case 1:
          return (
            <div className="file-uploading-container-gpicker">
              Uploading {this.state.progress}%
            </div>
          );
        case 2:
          return (
            <div className="preview-container">
              {this.props.type === "image" ? (
                <img
                  alt="img"
                  className="preview-img"
                  src={this.state.sasUrlWithoutToken}
                />
              ) : (
                <video width="100%" height="100%" controls>
                  <source
                    src={this.state.sasUrlWithoutToken}
                    type="video/mp4"
                  />
                </video>
              )}
              <img
                alt="img"
                className="remove-img"
                onClick={() => this.resetFile()}
                src={DeleteIcon}
              />
            </div>
          );
        default:
          return <div></div>;
      }
    };

    return (
      <React.Fragment>
        <div
          key={this.state.key}
          style={{
            width: `${this.props.width}`,
            height: `${this.props.height}`,
          }}
          className="graphic-select-container-gpicker"
        >
          {comp()}
        </div>

        {this.props.dimensionCheck.width != 1280 && (
          <span style={{ color: "red" }} className="file-upload-error">
            {this.state.errorMsg}
          </span>
        )}
      </React.Fragment>
    );
  }
}
